import React, { useEffect } from "react";
import { CheckBox, InputField } from "../../../lib";
import { useFormikContext } from "formik";
import { FieldsContainer } from "src/styles/Containers";

function AddClassesFields() {
  const formikProps = useFormikContext();
  const [focus, setFocus] = React.useState(true);

  useEffect(() => {
    formikProps.setTouched({});
    setFocus(false);
  }, []);

  return (
    <FieldsContainer>
      <InputField
        placeholder={"Class Name *"}
        name={"name"}
        inputRef={(input: any) => (focus ? input && input.focus() : null)}
        onFocus={(e: any) => {
          e.currentTarget.setSelectionRange(
            e.currentTarget.value.length,
            e.currentTarget.value.length
          );
        }}
      />
      <CheckBox name={"isLast"} placeholder={"Last Class"} />
    </FieldsContainer>
  );
}

export default AddClassesFields;
